import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type {
  ApiResponse,
  PaginatedApiResponse,
  Profile,
  Service,
  ServiceFilters,
} from "../interface";

export const serviceService = {
  async getAll(params: ServiceFilters = {}) {
    return cachedGet<PaginatedApiResponse<Service>>(
      API_ENDPOINTS.services.all,
      { params }
    );

  },

  async getBySlug(slug: string) {
    return cachedGet<ApiResponse<Service>>(
      API_ENDPOINTS.services.detail(slug)
    );

  },

  async getProfiles(slug: string) {
    return cachedGet<ApiResponse<Profile[]>>(
      API_ENDPOINTS.services.profiles(slug)
    );

  },
};
